import React from 'react';
import BaseButton from 'components/atoms/baseButton';
import classNames from 'classnames';
import { ArrowUpLightIcon } from 'components/atoms/icons/arrowUpLight';

import s from './styles.module.scss';

import type { IBaseButtonProps } from 'components/atoms/baseButton';
import type { MouseEvent } from 'react';

interface IProps {
  expanded: boolean;
  dataCy?: string;
  className?: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  size?: IBaseButtonProps['size'];
}

const ExpandButton: React.FC<IProps> = (props) => {
  const {
    expanded,
    onClick,
    className,
    size,
    dataCy = 'expand-button',
  } = props;

  const toggleIcon = (
    <i
      className={classNames(s.icon, {
        [s.opened]: expanded,
      })}
    >
      <ArrowUpLightIcon />
    </i>
  );

  return (
    <BaseButton
      className={className}
      type="secondary"
      onClick={onClick}
      icon={toggleIcon}
      dataCy={dataCy}
      size={size}
    />
  );
};

export default ExpandButton;
